import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';

import {
  AuthModule,
  AuthService,
  ConfigService,
  LanguageService,
  LoadingInterceptor,
  registerLocales,
  TmsLibModule,
} from 'tms-lib';
import { TmsWebGridService, TmsWebTranslationService } from 'tms-web-shared';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    TmsLibModule,
    AuthModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory:
        (
          authService: AuthService,
          gridService: TmsWebGridService,
          translationService: TmsWebTranslationService,
          configService: ConfigService,
        ) =>
        () => {
          authService.homeRoute = 'Home';
          gridService.load();
          translationService.load();
          return configService.load();
        },
      deps: [AuthService, TmsWebGridService, TmsWebTranslationService, ConfigService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: localStorage.getItem(LanguageService.LanguageKey) ?? LanguageService.DefaultLanguage,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    registerLocales();
  }
}
